import axios from "axios/index";

const lang = window.lang;
const baseURL = window.storeBaseURL
  ? window.storeBaseURL
  : "https://apidev.mobily.com.sa/apis/onpremise/eshop";

var token = window.clientToken;
var reGenerateTokenUrl = window.reGenerateToken;
var storeServerURL = window.storeServerURL;
const cem_key = window["CEM_KEY"];

let defaultHeaders = {
  params: {},
};

const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = "Bearer " + token;
    config.headers["cem-key"] = cem_key;
    return config;
  },
  (err) => {
    return err;
  }
);
axiosApiInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    if (
      (error.response.data.code &&
        error.response.data.code === "APIGEE-001" &&
        error.response.data.details.includes("Invalid access token")) ||
      (error.response.data.code &&
        error.response.data.code === "APIGEE-002" &&
        error.response.data.details.includes("Expired access token"))
    ) {
      // token = reGenerateToken();
      console.log(
        "in response error interceptors",
        JSON.stringify(error.response.config)
      );
      const { config: oldRequest } = error.response;

      return axiosApiInstance.request({ ...oldRequest });
    }

    document.location.href = `/wps/portal/web/personal/store/error?errorSource=${
      window.lang === "en" ? "Store" : "المتجر"
    }`;
    return error;
  }
);

function reGenerateToken() {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + reGenerateTokenUrl);

  return new Promise((resolve, reject) => {
    fetch(storeServerURL + "" + reGenerateTokenUrl, {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
        "cem-key": cem_key,
      },
    })
      .then((res) => res.text())

      .then((result) => {
        //console.log("Token res -> "+result);
        resolve(result);
      })
      .catch((err) => {
        //console.log(err);
        reject(err);
      });
  });
}

/**
 * Retrieves product details with sku_id given as parameter
 * @param sku_id
 * @returns {AxiosPromise<any>}
 */
const getProductDetailsBySKU = (sku_id) => {
  return axiosApiInstance.get(
    `${baseURL}/wp-json/wc/v3/products?lang=${lang}&sku=${sku_id}`,
    defaultHeaders
  );
};

/**
 * Add items to cart for checkout
 * @returns {AxiosPromise<any>}
 */
const addItemsToCart = (cart_key, product_id, variation_id) => {
  let data = {
    product_id: product_id,
    variation_id: variation_id,
    quantity: 1,
  };

  return axiosApiInstance.post(
    `${baseURL}/wp-json/cocart/v1/add-item?lang=${lang}&cart_key=${cart_key}`,
    data,
    defaultHeaders
  );
};

/**
 * Create Order
 * @returns {AxiosPromise<any>}
 */
const createOrder = (cart_key, latitude, longitude, address, values) => {
  let data = {
    terms: 1,
    latitude: latitude,
    longitude: longitude,
    phone: values.mobilyNumber,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    city: "Riyadh",
    country: "Saudi Arabia",
    postcode: "12345",
    full_address: address ? address : latitude + "," + longitude,
    payment_method: "cod",
    payment_method_title: "Payment on Delivery",
    mobily_customer_id: "mobily123",
    customer_note: "Provider: " + values.provider + " ODB: " + values.odbNumber,
  };

  return axiosApiInstance.post(
    `${baseURL}/wp-json/cocart/v1/create_order?lang=${lang}&cart_key=${cart_key}`,
    data,
    defaultHeaders
  );
};

export { addItemsToCart, createOrder, getProductDetailsBySKU };
